import { AnalyticsBrowser } from '@segment/analytics-next';

import { config } from '@/config';
import getEnv from '@/utils/get-env';

import { appendGroupIdPlugin } from './group-id-plugin';
import { obfuscateEventPropertiesPlugin } from './obfuscate-plugin';
import type { ValidSegmentEvents } from './types';

const { isProd } = getEnv();
const isStorybookRuntime = process.env.STORYBOOK === 'true';

const trackValidEvent = <T extends keyof ValidSegmentEvents>(
  event: T,
  payload: ValidSegmentEvents[T]
) => {
  segmentAnalyticsSDK?.track(event, payload);
};

let segmentAnalyticsSDK: ReturnType<typeof AnalyticsBrowser.load> | null = null;

if (!isStorybookRuntime) {
  segmentAnalyticsSDK = AnalyticsBrowser.load(
    {
      writeKey: config.SEGMENT_WRITE_KEY,
      ...(isProd ? { cdnURL: 'https://ud-cdn-services.gominerva.com' } : {}),
    },
    {
      integrations: {
        'Segment.io': {
          ...(isProd
            ? {
                apiHost: 'ud-api-services.gominerva.com/v1',
              }
            : {}),
          protocol: 'https',
        },
      },
    }
  );

  segmentAnalyticsSDK.register(
    appendGroupIdPlugin,
    obfuscateEventPropertiesPlugin
  );
}

export const analytics = {
  track: trackValidEvent,
  /**
   * Published Storybook is embedded cross-origin inside `minerva-docs`. It is
   * a review surface, not a real user session, so analytics should stay off to
   * avoid noisy CORS failures against the production Segment CDN bootstrap.
   */
  page: segmentAnalyticsSDK?.page ?? (() => undefined),
  identify: segmentAnalyticsSDK?.identify ?? (() => undefined),
  group: segmentAnalyticsSDK?.group ?? (() => undefined),
};
